import { useEffect } from 'react';

/**
 * Custom hook to capture window messages.
 */
const useListen = (config) => {
    const { enabled = true, messages } = config;
    useEffect(() => {
        if (!enabled)
            return;
        const handleMessage = (event) => {
            messages.forEach((config) => {
                if (event.data === config.message) {
                    config.cb();
                }
            });
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [messages, enabled]);
};

export { useListen };
